import React from "react";

const ProposedInfrastructure = ({ pfrFormData, setPfrFormData }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPfrFormData("proposedInfrastructure", {
      [name]: value,
    });
  };

  return (
    <>
      <div className="form-section">
        <h3>Proposed Infrastructure</h3>
        <div className="form-group">
          <label className="required">Industrial Area (Processing Area)</label>
          <textarea
            type="text"
            name="industrialArea"
            value={pfrFormData.proposedInfrastructure.industrialArea}
            onChange={handleInputChange}
            placeholder="Enter Industrial Area"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Residential area</label>
          <textarea
            type="text"
            name="residentialArea"
            value={pfrFormData.proposedInfrastructure.residentialArea}
            onChange={handleInputChange}
            placeholder="Enter Residential Area"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Greenbelt</label>
          <textarea
            type="text"
            name="greenbelt"
            value={pfrFormData.proposedInfrastructure.greenbelt}
            onChange={handleInputChange}
            placeholder="Enter Greenbelt"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Social Infrastructure</label>
          <textarea
            type="text"
            name="socialInfrastructure"
            value={pfrFormData.proposedInfrastructure.socialInfrastructure}
            onChange={handleInputChange}
            placeholder="Enter Social Infrastructure"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Connectivity </label>
          <textarea
            type="text"
            name="proposedInfrastructureConnectivity"
            value={
              pfrFormData.proposedInfrastructure
                .proposedInfrastructureConnectivity
            }
            onChange={handleInputChange}
            placeholder="Enter Connectivity"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Drinking Water Management</label>
          <textarea
            type="text"
            name="drinkingWaterManagement"
            value={pfrFormData.proposedInfrastructure.drinkingWaterManagement}
            onChange={handleInputChange}
            placeholder="Enter Drinking Water Management"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Sewerage System</label>
          <textarea
            type="text"
            name="sewerageSystem"
            value={pfrFormData.proposedInfrastructure.sewerageSystem}
            onChange={handleInputChange}
            placeholder="Enter Sewerage System"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Industrial waste management</label>
          <textarea
            type="text"
            name="industrialWasteManagement"
            value={pfrFormData.proposedInfrastructure.industrialWasteManagement}
            onChange={handleInputChange}
            placeholder="Enter Industrial waste management"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Solid waste management</label>
          <textarea
            type="text"
            name="solidWasteManagement"
            value={pfrFormData.proposedInfrastructure.solidWasteManagement}
            onChange={handleInputChange}
            placeholder="Enter Solid waste management"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Power Requirement & supply/source</label>
          <textarea
            type="text"
            name="powerSupply"
            value={pfrFormData.proposedInfrastructure.powerSupply}
            onChange={handleInputChange}
            placeholder="Enter Power Supply"
            required
          />
        </div>
      </div>
    </>
  );
};

export default ProposedInfrastructure;
